<template>
  <div class="palette-button-wrap" :style="isPCPreview ? getIconPosition : ''">
    <span v-if="isPCPreview" class="iconfont iconshoujiyulan change-device" @click="handleChangeDevice"></span>
    <span v-else class="iconfont iconzengjiayulan-04-05-05 change-device" @click="handleChangeDevice"></span>
    <span class="iconfont iconzengjiayulan-04 close-preview" @click="handleClosePreview"></span>
  </div>
</template>

<script>
export default {
  props: {
    isPCPreview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getIconPosition () {
      if (document.body.clientWidth < 1175) {
        return 'right: 2%'
      }
      return `left: ${1000 + (document.body.clientWidth - 1000) / 2 + 48}px`
    }
  },
  methods: {
    handleClosePreview () {
      this.$emit('closePreview')
    },
    handleChangeDevice () {
      this.$emit('changeDevice')
    }
  }
}
</script>

<style lang="scss" scoped>
.palette-button-wrap {
  position: fixed;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 280px;
  z-index: 9;

  .change-device, .close-preview {
    font-size: 58px;
    color: #606266;
    cursor: pointer;
  }

  .change-device {
    margin-bottom: 10px;
  }
}
</style>
